import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const uploadApi = {
  /**
   * STEP 1: Get pre-signed URL for photo upload
   * Endpoint: POST /api/posts/upload-photo
   * Body: { filename, contentType }
   * Response: { uploadUrl, key, maxSize }
   */
  getPhotoUploadUrl: async (filename, contentType) => {
    return apiClient.post("/posts/upload-photo", { filename, contentType });
  },

  /**
   * STEP 2: Upload file directly to S3
   */
  uploadToS3: async (uploadUrl, file, contentType, onProgress) => {
    return axios.put(uploadUrl, file, {
      headers: { "Content-Type": contentType },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        if (onProgress) onProgress(percentCompleted);
      },
    });
  },

  /**
   * COMPLETE PHOTO UPLOAD FLOW
   */
  uploadPhoto: async (file, onProgress) => {
    try {
      // Step 1: Get pre-signed URL
      const { data } = await uploadApi.getPhotoUploadUrl(file.name, file.type);

      // Step 2: Upload to S3
      await uploadApi.uploadToS3(data.uploadUrl, file, file.type, onProgress);

      // Return key for post creation
      return { key: data.key, success: true };
    } catch (error) {
      throw error;
    }
  },

  /**
   * GET PAPER PDF UPLOAD URL
   * Endpoint: POST /api/posts/upload-paper-pdf
   */
  getPaperUploadUrl: async (filename, contentType) => {
    return apiClient.post("/posts/upload-paper-pdf", { filename, contentType });
  },

  /**
   * COMPLETE PAPER UPLOAD FLOW
   */
  uploadPaperPdf: async (file, onProgress) => {
    try {
      const { data } = await uploadApi.getPaperUploadUrl(file.name, file.type);
      await uploadApi.uploadToS3(data.uploadUrl, file, file.type, onProgress);
      return { key: data.key, success: true };
    } catch (error) {
      throw error;
    }
  },
};

export default uploadApi;
